export enum ThreadCategory {
  customer = 'customer',
  accountant = 'accountant'
}
